// MT-042 (break-glass): el profesional declara una emergencia sobre un paciente (motivo obligatorio) y el servidor abre su expediente por unas horas.
import { vaultUrl } from '@/lib/hceVault';
import { cabecerasBoveda } from '@/lib/audit/auditedFetch';

export const MOTIVO_EMERGENCIA_MIN = 10;
export const MOTIVO_EMERGENCIA_MAX = 500;

export type ResultadoEmergencia = { ok: true; hasta: number; horas: number; existente?: boolean } | { ok: false; error: string };

/** ¿La respuesta de acceso denegado dice que el profesional puede declarar una emergencia? */
export function puedeEmergenciaDe(err: unknown): boolean {
  return (err as { outcome?: { puedeEmergencia?: unknown } } | null)?.outcome?.puedeEmergencia === true;
}

export async function declararEmergencia(pacienteId: string, motivo: string): Promise<ResultadoEmergencia> {
  const texto = motivo.trim();
  if (texto.length < MOTIVO_EMERGENCIA_MIN) return { ok: false, error: `Describe el motivo de la emergencia (al menos ${MOTIVO_EMERGENCIA_MIN} caracteres).` };
  try {
    const res = await fetch(vaultUrl('/api/hce/acceso-emergencia'), { method: 'POST', headers: cabecerasBoveda(), body: JSON.stringify({ paciente: pacienteId, motivo: texto }) });
    const datos = await res.json().catch(() => ({}));
    if (!res.ok) return { ok: false, error: typeof datos?.error === 'string' ? datos.error : 'No se pudo abrir el acceso de emergencia.' };
    return { ok: true, hasta: Number(datos.hasta), horas: Number(datos.horas) };
  } catch {
    return { ok: false, error: 'No se pudo abrir el acceso de emergencia. Reintenta.' };
  }
}
